export default __webpack_public_path__ + "static/media/Title.b660b164.png";